import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'
import IconLocationCompany from '@/shared/icons/NewDesign/IconLocationCompany'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import { ModuleContent } from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import { StyledContainer } from '@/containers/SubscriptionFormPageNew/Components/Distributor/styled-components'

interface DistributorLoadingProps {
  title: string
  text: string
}

const DistributorLoading = ({ title, text }: DistributorLoadingProps) => {
  const { expanded, toggle } = useModuleCollapse('distributor')

  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconLocationCompany} moduleKey='distributor'>
          {title}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='distributor' />
      </ModuleHeader>
      <ModuleContent hidden={!expanded}>
        <SDLoader text={text} />
      </ModuleContent>
    </StyledContainer>
  )
}

export default DistributorLoading
